<template>
    <div
        v-if="mapInitialized"
        class="ct-aside-control ct-aside-data ct-aside-left ct-aside-control-light panel-layers"
        :class="{'ct-aside-control-slide-open': showModal}"
        :data-panel="idPanel">
        <div class="ct-aside-control-actions">
            <button type="button" title="Fechar" @click="closeModal(idPanel)" class="close position-absolute pos-top pos-right" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">
                    <!-- <i class="fas fa-times"></i> -->
                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-13"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" class=""></path></svg>
                </span>
            </button>
        </div>
        <div class="ct-aside-control-content h-100">
            <div class="ct-aside-control-item accordion d-sm-none" v-if="enableToolFilterStatus">
                <!-- Filtros por Status-->
                <map-filter-status-control
                    v-if="enableToolFilterStatus"
                    :moduleCode="moduleCode"
                    :aside="true"
                    :asideExpanded="true"
                    asideCss="card"
                    asideCssHeader="ct-aside-control-header"
                    asideCssBody="ct-aside-control-body collapse-transition"
                />
            </div>
            <div class="ct-aside-control-item accordion d-sm-none" v-if="enableToolFilterTypes">
                <!-- Filtros por Status-->
                <map-filter-types-control
                    v-if="enableToolFilterTypes"
                    :moduleCode="moduleCode"
                    :aside="true"
                    :asideExpanded="false"
                    asideCss="card"
                    asideCssHeader="ct-aside-control-header"
                    asideCssBody="ct-aside-control-body collapse-transition"
                />
            </div>
            <div class="ct-aside-control-item accordion h-100" v-if="enableToolMapLayers">
                <div class="card h-100">
                    <div class="ct-aside-control-header d-flex flex-column mb-2">
                        <a class="w-100" aria-controls="#map-layers" href="#map-layers" @click.prevent="toggle('layers')"
                            data-toggle="collapse" role="button" :aria-expanded="expanded.layers">
                            <div class="title">
                                Camadas do mapa
                                <span class="right icon-collapse svg" :class="{'show': expanded.layers}" v-if="expanded.active"></span>
                            </div>
                        </a>
                        <div class="w-100 form-inline">
                            <div class="input-group sidebar-search w-100" data-widget="sidebar-search">
                                <input class="form-control py-2 shadow-none border-right-0 border" v-model="inputLayer" type="search" placeholder="Pesquise..." aria-label="Search">
                                <span class="input-group-append">
                                    <div class="input-group-text bg-transparent">
                                        <i class="fa fa-filter"></i>
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div class="w-100 form-inline">
                            <div class="input-group sidebar-actions-layer w-100" data-widget="sidebar-actions-layer">
                                <div class="btn-toolbar w-100 justify-content-center" role="toolbar" aria-label="">
                                    <div v-if="isLayerSelected" class="btn-group btn-block" role="group" aria-label="Layer Actions">
                                        <button
                                            v-for="(layerAction) in filteredLayerActions"
                                            :key="`layer-${layerAction.id}`"
                                            :title="layerAction.title"
                                            @click.prevent="applyAction(layerAction, $event)"
                                            type="button"
                                            class="btn btn-main min-w-auto action-layer"
                                            data-toggle="tooltip-city"
                                        >
                                            <i v-if="layerAction.icon" class="" :class="layerAction.icon"></i>
                                            <span v-else-if="layerAction.image" v-html="layerAction.image">
                                            </span>
                                        </button>
                                    </div>
                                    <div v-else-if="isGroupSelected" class="btn-group" role="group" aria-label="Group Actions">
                                        <button
                                            v-for="(groupAction) in filteredGroupActions"
                                            :key="`group-action-${groupAction.id}`"
                                            :title="groupAction.title"
                                            @click.prevent="applyAction(groupAction, $event)"
                                            type="button"
                                            class="btn btn-main min-w-auto"
                                            data-toggle="tooltip-city"
                                        >
                                            <i v-if="groupAction.icon" class="" :class="groupAction.icon"></i>
                                            <span v-else-if="groupAction.image" v-html="groupAction.image">
                                            </span>
                                        </button>
                                    </div>
                                    <div v-else class="btn-group" role="group" aria-label="Global Actions">
                                        <button
                                            v-for="(globalAction) in filteredGlobalActions"
                                            :key="`global-action-${globalAction.id}`"
                                            :title="globalAction.title"
                                            @click.prevent="applyAction(globalAction, $event)"
                                            type="button"
                                            class="btn btn-main min-w-auto"
                                            data-toggle="tooltip-city"
                                        >
                                            <i v-if="globalAction.icon" class="" :class="globalAction.icon"></i>
                                            <span v-else-if="globalAction.image" v-html="globalAction.image">
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ct-aside-control-body p-0"
                        :class="{'show': expanded.layers}">
                        <div class="ct-aside-control-menu-wrapper flex-fill">
                            <div class="ct-aside-control-menu">
                                <nav class="">
                                    <tree-layers
                                        v-if="loaded"
                                        class="ct-aside-control-menu-nav nav nav-pills nav-sidebar flex-column"
                                        ref="layers-tree"
                                        :nodes="getLayers()"
                                        :map="getMap()"
                                        :nodeActions="enabledLayerGenericActions"
                                        :activeSelect="enableTools"
                                        @emitNodeSelected="onNodeSelected"
                                        @emitNodeAdded="onNodeAdded"
                                        @emitNodeAction="(action, node, evt) => this.applyAction(action, evt, node)"
                                    />
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <layer-download
            v-if="!!exportLayerAction"
            ref="modalLayerDownload"
            :url="urlLayerSelected"
            :layer="selectedNode"
        />

    </div>
</template>

<script>
    import ButtonControlMixin from '../mixins/ButtonControlMixin';
    import { detectMobile } from '@config/browser';
    import { isFunction, debounce, behaviorGroup, behaviorItem as behaviorLayer, isObject, isArray, uniqArray, head, getTocLayerId } from '@config/utils';
    import { reprojectBbox, normalizeSRS } from '../shared/catalog/utils/CoordinatesUtils';
    import { getAvailableInfoFormatValues, getLabelFromValue as getFormatFromValue } from '../shared/catalog/utils/MapInfoUtils';
    import {get as getProjection} from 'ol/proj';
    import urlUtil from 'url';

    export default {
        components: {
            TreeLayers: () => import(/* webpackChunkName: "tree-layers-component" */ '../shared/layer/components/TreeLayersComponent'),
            LayerDownload: () => import(/* webpackChunkName: "layer-download-component" */ '../shared/layer/components/LayerDownloadComponent'),
            MapFilterTypesControl: () => import(/* webpackChunkName: "map-filter-types-control" */ '@/components/maps/control/filterTypesControl'),
            MapFilterStatusControl: () => import(/* webpackChunkName: "map-filter-status-control" */ '@/components/maps/control/filterStatusControl'),
        },
        mixins: [
            ButtonControlMixin,
        ],
        zindex: {
            extra_layer: 100,
        },
        props: {
            enableToolFilterTypes:
            {
                type: Boolean,
                default: false
            },
            enableToolFilterStatus:
            {
                type: Boolean,
                default: false
            },
            enableToolMapLayers:
            {
                type: Boolean,
                default: false
            },
            enableTools:
            {
                type: Boolean,
                default: true
            },
        },
        data() {
            const idPanel = 'layers';
            return {
                idPanel: idPanel,
                idPanelCatalog: 'catalog',
                className: 'ol-layers',
                layers: {
                    id: 0,
                    root: true,
                    name: 'Root',
                    behavior: behaviorGroup,
                    children:[]
                },
                selectedNode: null,
                inputLayer: null,
                expanded: {
                    active: detectMobile() && (this.enableToolFilterTypes || this.enableToolFilterStatus),
                    layers: !(this.enableToolFilterTypes || this.enableToolFilterStatus) && !detectMobile(),
                    filterStatus: true,
                },
                loaded: false,
                downloading: false,
            }
        },
        created () {
            this.$eventBus.listen(this.moduleCode, 'map.new-feature-initialize', this.closeModal);
            this.$eventBus.listen(this.moduleCode, 'map.start-street-view-panorama', this.closeModal);
            this.$eventBus.listen(this.moduleCode, 'toc.add-layer-from-catalogs', this.onAddLayerFromCatalogs);
        },
        beforeDestroy() {
            this.$eventBus.remove(this.moduleCode, 'map.new-feature-initialize', this.closeModal);
            this.$eventBus.remove(this.moduleCode, 'map.start-street-view-panorama', this.closeModal);
            this.$eventBus.remove(this.moduleCode, 'toc.add-layer-from-catalogs', this.onAddLayerFromCatalogs);
            this.reset();
        },
        computed: {
            globalActions() {
                return [
                    {
                        id: 'add_layer',
                        title: this.$t(`${this.idPanel}.actions.globalActions.add_layer`),
                        icon: '',
                        image: '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="layer-plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-layer-plus fa-w-16"><path fill="currentColor" d="M492.88 354.58L413.19 320l79.68-34.58c12.16-5.28 17.72-19.41 12.47-31.56-5.28-12.17-19.38-17.67-31.59-12.47l-217.22 94.72L71.91 256l170.5-73.98c12.16-5.28 17.72-19.41 12.47-31.56-5.28-12.19-19.38-17.67-31.59-12.47L19.16 226.56C7.53 231.59 0 243.16 0 256s7.53 24.41 19.12 29.42L98.82 320l-79.67 34.56C7.53 359.59 0 371.16 0 384.02c0 12.84 7.53 24.41 19.12 29.42l218.28 94.69a46.488 46.488 0 0 0 18.59 3.88c6.34-.02 12.69-1.3 18.59-3.86l218.25-94.69c11.62-5.03 19.16-16.59 19.16-29.44.01-12.86-7.52-24.43-19.11-29.44zM256.53 464.11L71.91 384l87.22-37.84 78.28 33.96c5.91 2.58 12.25 3.86 18.59 3.86s12.69-1.28 18.59-3.84l78.3-33.98 87.29 37.88-183.65 80.07zM496 88h-72V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v72h-72c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h72v72c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-72h72c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z" class=""></path></svg>',
                        status: this.enableTools,
                        active: this.enableCatalog && this.isPanelCatalogActive && !this.isPanelCatalogVisible,
                        catalog: true,
                    },
                    {
                        id: 'add_group',
                        title: this.$t(`${this.idPanel}.actions.globalActions.add_group`),
                        icon: 'fas fa-folder-plus',
                        status: this.enableTools,
                        active: this.enableCatalog,
                        catalog: true,
                    }
                ];
            },
            groupActions() {
                return [
                    {
                        id: 'add_layer_subgroup',
                        title: this.$t(`${this.idPanel}.actions.groupActions.add_layer_subgroup`),
                        icon: '',
                        image: '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="layer-plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-layer-plus fa-w-16"><path fill="currentColor" d="M492.88 354.58L413.19 320l79.68-34.58c12.16-5.28 17.72-19.41 12.47-31.56-5.28-12.17-19.38-17.67-31.59-12.47l-217.22 94.72L71.91 256l170.5-73.98c12.16-5.28 17.72-19.41 12.47-31.56-5.28-12.19-19.38-17.67-31.59-12.47L19.16 226.56C7.53 231.59 0 243.16 0 256s7.53 24.41 19.12 29.42L98.82 320l-79.67 34.56C7.53 359.59 0 371.16 0 384.02c0 12.84 7.53 24.41 19.12 29.42l218.28 94.69a46.488 46.488 0 0 0 18.59 3.88c6.34-.02 12.69-1.3 18.59-3.86l218.25-94.69c11.62-5.03 19.16-16.59 19.16-29.44.01-12.86-7.52-24.43-19.11-29.44zM256.53 464.11L71.91 384l87.22-37.84 78.28 33.96c5.91 2.58 12.25 3.86 18.59 3.86s12.69-1.28 18.59-3.84l78.3-33.98 87.29 37.88-183.65 80.07zM496 88h-72V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v72h-72c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h72v72c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-72h72c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z" class=""></path></svg>',
                        status: this.enableTools,
                        active: this.enableCatalog,
                        catalog: true,
                    },
                    {
                        id: 'add_subgroup',
                        title: this.$t(`${this.idPanel}.actions.groupActions.add_subgroup`),
                        icon: 'fas fa-folder-plus',
                        status: this.enableTools,
                        active: this.enableCatalog,
                        catalog: true,
                    },
                    {
                        id: 'remove_group',
                        title: this.$t(`${this.idPanel}.actions.groupActions.remove_group`),
                        icon: 'far fa-trash-alt',
                        status: this.enableTools,
                        active: this.enableCatalog,
                        catalog: true,
                    }
                ];
            },
            layerActions() {
                return [
                    {
                        id: 'zoom_to',
                        title: this.$t(`${this.idPanel}.actions.layerActions.zoom_to`),
                        icon: 'fas fa-search-plus',
                        status: this.enableTools,
                        active: (node) => this.checkEpsgSupported(node),
                    },
                    {
                        id: 'metadata_link',
                        title: this.$t(`${this.idPanel}.actions.layerActions.metadata_url`),
                        icon: 'fas fa-info',
                        status: this.enableTools,
                        active: function(node) { return this.items(node).length>0;},
                        items: (node) => this.metadataLinks(node),
                    },
                    {
                        id: 'data_link',
                        title: this.$t(`${this.idPanel}.actions.layerActions.data_url`),
                        icon: 'fas fa-database',
                        status: this.enableTools,
                        active: function(node) { return this.items(node).length>0;},
                        items: (node) => this.dataLinks(node),
                    },
                    {
                        id: 'attribute_table',
                        title: this.$t(`${this.idPanel}.actions.layerActions.attribute_table`),
                        icon: 'fas fa-table',
                        status: false,
                        active: true,
                    },
                    {
                        id: 'export_layer',
                        title: this.$t(`${this.idPanel}.actions.layerActions.export_layer`),
                        icon: 'fas fa-download',
                        status: false,
                        active: this.selectedNode && ((this.selectedNode.type
                        || (this.selectedNode.service && this.selectedNode.service.code ? this.selectedNode.service.code.toLowerCase() : null))  === 'wms'),
                    },
                    {
                        id: 'remove_layer',
                        title: this.$t(`${this.idPanel}.actions.layerActions.remove_layer`),
                        icon: 'far fa-trash-alt',
                        status: this.enableTools,
                        active: this.enableCatalog,
                        catalog: true,
                    },
                ];
            },
            showModal() {
                return this.isActive && this.isPanelVisible;
            },
            groupSelectable() {
                return this.enableTools && this.filteredGroupActions.length>0;
            },
            layerSelectable() {
                return this.enableTools && this.filteredLayerActions.length>0;
            },
            isGroupSelected() {
                // return this.selectedNode && this.selectedNode.children;
                return this.selectedNode && this.selectedNode.behavior == behaviorGroup;
            },
            isLayerSelected() {
                // return this.selectedNode && (this.selectedNode.layers || this.selectedNode.resources);
                return this.selectedNode && this.selectedNode.behavior == behaviorLayer;
            },
            isPanelCatalogActive(){
                return this.$store.getters[`${this.moduleCode}/isPanelActive`](this.idPanelCatalog);
            },
            isPanelCatalogVisible(){
                return this.$store.getters[`${this.moduleCode}/isPanelVisible`](this.idPanelCatalog);
            },
            isEpsgSupported() {
                let node = this.selectedNode;
                return this.checkEpsgSupported(node);
            },
            urlLayerSelected(){
                return this.selectedNode ? this.selectedNode.url || this.selectedNode.addr : null;
            },
            hasMetadata() {
                let node = this.selectedNode;
                return this.metadataLinks(node).length>0;
            },
            metadata() {
                return this.tool.metadata || {};
            },
            enabledGlobalActions() {
                return this.globalActions.filter((obj) => obj.status);
            },
            filteredGlobalActions() {
                return this.enabledGlobalActions.filter((obj) => !!(isFunction(obj.active) ? obj.active(obj) : obj.active));
            },
            enabledGroupActions() {
                return this.groupActions.filter((obj) => obj.status);
            },
            enabledGroupTocActions() {
                return this.enabledGroupActions;
            },
            filteredGroupActions() {
                return this.enabledGroupTocActions.filter((obj) => !!(isFunction(obj.active) ? obj.active(obj) : obj.active));
            },
            enabledLayerActions() {
                return this.layerActions.filter((obj) => obj.status);
            },
            enabledLayerTocActions() {
                return this.enabledLayerActions.filter((obj) => !!obj.catalog);
            },
            enabledLayerGenericActions() {
                return this.enabledLayerActions.filter((obj) => !!!obj.catalog);
            },
            exportLayerAction() {
                return this.enabledLayerGenericActions.find(obj => obj.id == 'export_layer');
            },
            filteredLayerActions() {
                return this.enabledLayerTocActions.filter((obj) => !!(isFunction(obj.active) ? obj.active(obj) : obj.active));
            },
            layersTree() {
                return this.$refs ? this.$refs["layers-tree"] : null;
            }
        },
        methods: {
            updatePanel(params = {}) {
                try {
                    this.$store.dispatch('setPanel', {...params, ...{module: this.moduleCode, id: this.idPanel}});
                }catch(error) {
                    if(this.$root.$env.DEBUG){
                        console.error(error);
                    }
                }
            },
            closeModal() {
                this.closePanel();
            },
            toggle(id) {
                if(this.enableToolFilterStatus || this.enableToolFilterTypes)
                    this.expanded[id] = !this.expanded[id];
            },
            reset() {
                this.$set(this.layers, 'children', []);
                this.selectedNode = null;
                this.inputLayer = null;
                this.downloading = null;
            },
            addButtonMap(_map) {
                if(!this.enableToolMapLayers)
                    return false;

                let btn = _map.createBtnImg(
                    this.assetsPathTheme('/map/layers.svg'),
                    _map.getControlClassName(this.orderClassName),
                    this.title,
                    [
                        {
                            type: 'click',
                            event: (evt) =>
                            {
                                this.openPanel();
                                evt.stopPropagation();
                            }
                        }
                    ],
                    this.lblBtn
                );
                _map.addControl(this.posBtnMap, btn);
                this.$eventBus.listen(this.moduleCode, 'map.new-feature-initialize', (evt)=>{
                    let el = $(btn.element); if(el) el.hide()
                });
                this.$eventBus.listen(this.moduleCode, 'map.new-feature-finished', (evt)=>{
                    let el = $(btn.element); if(el) el.show()
                });
                return btn;
            },
            async loadLayers() {
                if(!this.enableToolMapLayers){
                    return null;
                }

                let url = this.url.getLayers;
                if (!this.loaded && url) {
                    await this.$http.get(this.formatUrl(url, {applicationCode: this.applicationCode}))
                    .then(res => {
                        // this.$set(this.layers, 'children', res.data.data);
                        this.layers.children = [...res?.data?.data] || [];

                        const countLayers = node => {
                            if(!node.children) return 1;
                            let c = node.children.reduce((a, e) => e.resources ? a + 1 : a, 0); //node.children.length;
                            c += node.children.reduce((a, e) => a + countLayers(e), 0);
                            return c; // return the count to be used by parent objects
                        }
                        let num = this.$options.zindex.extra_layer + countLayers(this.layers);

                        const allChildrens = node => {
                            const defaultState = { loaded: false, loading: false, checked: false, collapsed: true, selected: false, filtered: true, opacity: 1 };
                            node.icon_layer = this.getIconLayer(node);
                            node.legend_layer = this.getLegendLayer(node);
                            node.selectable = this.groupSelectable;
                            node.state = {
                                ...defaultState,
                                ...{
                                    checked: !!node.visible,
                                    collapsed: !!node.collapse,
                                    filtered: true,
                                    opacity: 1,
                                }
                            };
                            // this.$set(node, 'selectable', this.groupSelectable);
                            for (var i = 0; i < node.children.length; i++) {
                                let child = node.children[i];
                                allChildrens(child);
                                if(child.resources){
                                    child.selectable = this.layerSelectable;
                                    // this.$set(child, 'selectable', this.layerSelectable);
                                    child.state = {
                                        ...defaultState,
                                        ...{
                                            checked: !!child.visible,
                                            collapsed: !!child.collapse,
                                            filtered: true,
                                            opacity: 1,
                                        }
                                    };
                                    // this.$set(child, 'filtered', true);
                                    // this.$set(child, 'opacity', 1);

                                    child.zindex = num;
                                    num--;
                                }
                            }
                        }
                        allChildrens(this.layers);

                        this.updatePanel({'loaded': true});
                        this.loaded = true;
                    }, (error) => {
                        this.showHttpError(error);
                    }).catch(error => {
                        console.error(error)
                    })
                    .finally(() => {
                        this.activeTooltip();
                        // let _map = this.getMap().getOLMap();
                        // console.log(_map, _map.getLayers(), _map.getOverlays(), _map.getLayerGroup())
                    })
                }
                return Promise.resolve(false);
            },
            layerNode(node){
                return node ? (node.resources && node.resources.length ? node.resources[0] : node) : null;
            },
            checkEpsgSupported(node) {
                node = this.layerNode(node);
                if(node){
                    let _map = this.getMap();
                    let layer = _map.getLayer(getTocLayerId(node));
                    if(layer){
                        const selectedLayers = [layer];
                        const layersBbox = selectedLayers.filter(l => l.get('bbox')).map(l => l.get('bbox'));
                        if(layersBbox.length){
                            const uniqueCRS = layersBbox.length > 0 ? layersBbox.reduce((a, b) => a.crs === b.crs ? a : { crs: 'differentCRS' }) : { crs: 'differentCRS' };
                            const currentEPSG = !!head(layersBbox) && uniqueCRS.crs !== 'differentCRS' && uniqueCRS.crs;
                            return !!(currentEPSG && getProjection(currentEPSG));
                            // return !!(currentEPSG && proj4.defs(currentEPSG));
                        }
                    }
                }
                return false;
            },
            metadataLinks(node) {
                let links = [];
                node = this.layerNode(node);
                if(node){
                    let metadata_links = node.metadata || [];
                    metadata_links.map(link => {
                        link.name = link.name || this.$t(`${this.idPanel}.metadata.metadata_url`);
                    })
                    links = metadata_links;
                }
                return links;
            },
            dataLinks(node) {
                let links = [];
                node = this.layerNode(node);
                if(node){
                    let data_links = node.data_links || [];
                    data_links.map(link => {
                        link.name = link.name || this.$t(`${this.idPanel}.metadata.data_url`);
                    })
                    links = data_links;
                }
                return links;
            },
            onNodeSelected(nodeSelected) {
                if(this.enableTools){
                    this.selectedNode = nodeSelected;
                    this.$store.dispatch(`tocSetSelected`, {
                        'idModule': this.moduleCode,
                        'selected': this.selectedNode ? this.selectedNode.id : null
                    });
                }
            },
            onNodeAdded(nodeAdded) {
                if(this.enableTools){
                    this.onZoom(nodeAdded);
                }
            },
            applyAction(action, evt, node) {
                this.hideTooltip();
                let item = node || this.selectedNode;
                let key = action.id;
                switch(key) {
                    case 'add_layer':
                    case 'add_layer_subgroup':
                        this.openPanel(this.idPanelCatalog);
                        break;
                    case 'add_group':
                    case 'add_subgroup':
                        this.$root.$emit('openPrompt', {
                            id: item ? item.id : null,
                            data: null,
                            text: 'Nome do Grupo',
                            callback: (itemId, grp_name) => {
                                let newNode = {
                                    name: grp_name,
                                    behavior: behaviorGroup,
                                    icon: 'fas fa-cube',
                                    icon_bg_color: '#008FB6',
                                    collapse: true,
                                    filtered: true,
                                    children: [],
                                };
                                this.insertNodeIntoTree(newNode, itemId || this.layers.id);
                            },
                            title: 'Adicionar Grupo',
                        });
                        break;
                    case 'zoom_to':
                        this.onZoom(item);
                        break;
                    case 'metadata_link':
                    case 'data_link':
                        this.onOpenMetadataLinks(action, item, evt);
                        break;
                    case 'attribute_table':
                        // code block
                        break;
                    case 'remove_group':
                    case 'remove_layer':
                        this.$root.$emit('openConfirmation', {
                            id: item.id,
                            data: null,
                            text: 'Deseja remover '+ (key == 'remove_group' ? 'o grupo' : 'a camada') + ' <strong class=\'font-weight-bold\'>'+item.name+'</strong>?',
                            callback: (itemId) => {
                                this.deleteNodeFromTree(this.layers, itemId);
                            }
                        });
                        break;
                    case 'export_layer':
                        this.onDownload(item);
                        break;
                    default:
                        // code block
                }
            },
            getNodeFromTree(node, nodeId) {
                if (node.id == nodeId) {
                    return node;
                } else if (node.children != null) {
                    let result = null;
                    for (let i = 0; result == null && i < node.children.length; i++) {
                        result = this.getNodeFromTree(node.children[i], nodeId);
                    }
                    return result;
                }
                return null;
            },
            insertNodeIntoTree(newNode, nodeId) {
                newNode.id = newNode.id || getTocLayerId(newNode);
                let tree = this.layersTree;
                if(tree) {
                    tree.insertNode(newNode, nodeId);
                }
            },
            // updateNodeInTree(node, nodeId, newNode) {
            //     if (node.id == nodeId) {
            //         node.name = newNode.nodeName;
            //     } else if (node.children != null) {
            //         for (let i = 0; i < node.children.length; i++) {
            //             result = this.updateNodeInTree(node.children[i], nodeId, newNode);
            //         }
            //     }
            // },
            deleteNodeFromTree(node, nodeId) {
                let tree = this.layersTree;
                if(tree) {
                    tree.deleteNode(nodeId);
                }
            },
            // ckeckActiveTool(keyAction){
            //     // this.enableCatalog
            //     if(keyAction.startsWith('add_layer')){
            //         return this.isPanelCatalogActive && !this.isPanelCatalogVisible;
            //     }else if(keyAction == 'zoom_to'){
            //         return this.isEpsgSupported;
            //     }else if(keyAction == 'export_layer'){
            //         return (this.selectedNode && (this.selectedNode.type
            //                     || (this.selectedNode.service && this.selectedNode.service.code ? this.selectedNode.service.code.toLowerCase() : null))  === 'wms');
            //     }else if(keyAction == 'metadata'){
            //         return this.hasMetadata;
            //     }
            //     return true;
            // },
            onZoom(node) {
                node = this.layerNode(node);
                if(this.checkEpsgSupported(node)){
                    const _map = this.getMap();
                    let layer = _map.getLayer(getTocLayerId(node));
                    if(layer){
                        const selectedLayers = [layer];
                        const layersBbox = selectedLayers.filter(l => l.get('bbox')).map(l => l.get('bbox'));
                        const bbox = layersBbox.length > 1 ? layersBbox.reduce((a, b) => {
                            return {
                                bounds: {
                                    maxx: a.bounds.maxx > b.bounds.maxx ? a.bounds.maxx : b.bounds.maxx,
                                    maxy: a.bounds.maxy > b.bounds.maxy ? a.bounds.maxy : b.bounds.maxy,
                                    minx: a.bounds.minx < b.bounds.minx ? a.bounds.minx : b.bounds.minx,
                                    miny: a.bounds.miny < b.bounds.miny ? a.bounds.miny : b.bounds.miny
                                },
                                crs: b.crs
                            };
                        }, layersBbox[0]) : layersBbox[0];

                        let extent = this.toBoundsArray(bbox.bounds);
                        let bounds = reprojectBbox(extent, normalizeSRS(bbox.crs), _map.getProjection().getCode() || "EPSG:4326");
                        if (bounds) {
                            _map.zoomToExtent(bounds);
                        }
                    }
                }
            },
            onOpenMetadataLinks(action, node, evt) {
                let links = action.items ? (isFunction(action.items) ? action.items(node) : action.items) : [];
                let el = evt ? $(evt.target) : null;
                el = el.is('.btn') ? el : el.prev('.btn');
                if(links && links.length>0){
                    if(links.length>1){
                        let ul = document.createElement("ul");
                        ul.setAttribute('class', 'list-group list-group-flush');
                        ul.click(function(e){
                            e.preventDefault();
                        });

                        links.forEach( (item) =>{
                            let link = document.createElement('a');
                            link.setAttribute('class', '');
                            link.setAttribute('target', '_blank');
                            link.setAttribute('href', item.url);
                            link.appendChild(document.createTextNode(item.name));
                            let li = document.createElement('li');
                            li.setAttribute('class', 'list-group-item');
                            li.appendChild(link);
                            ul.appendChild(li);
                        });

                        el.tooltip('hide')
                        .popover('dispose')
                        .popover({
                            placement:'right',
                            toggle: "popover",
                            trigger: 'focus',
                            html: true,
                            selector: false,
                            sanitize: false,
                            template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-body"></div></div>',
                            title: '',
                            content: ul,
                        })
                        .popover('show');

                    }else{
                        let item = links[0];
                        window.open(item.url);
                    }
                }
            },
            // onMetadata(node, evt) {
            //     let el = $(evt.target);
            //     el = el.is( ":button" ) ? el : el.closest('button');
            //     // el.popover('dispose').tooltip('hide');

            //     node = this.layerNode(node);
            //     let links = this.metadataLinks(node);
            //     // links = [links[0]];
            //     if(links.length>0){
            //         if(links.length>1){
            //             let ul = document.createElement("ul");
            //             ul.setAttribute('class', 'list-group list-group-flush');
            //             ul.click(function(e){
            //                 e.preventDefault();
            //             });

            //             links.forEach( (item) =>{
            //                 let link = document.createElement('a');
            //                 link.setAttribute('class', '');
            //                 link.setAttribute('target', '_blank');
            //                 link.setAttribute('href', item.url);
            //                 link.appendChild(document.createTextNode(item.name));
            //                 let li = document.createElement('li');
            //                 li.setAttribute('class', 'list-group-item');
            //                 li.appendChild(link);
            //                 ul.appendChild(li);
            //             });

            //             el.popover('dispose')
            //             .tooltip('hide')
            //             .popover({
            //                 placement:'right',
            //                 toggle: "popover",
            //                 trigger: 'focus',
            //                 html: true,
            //                 selector: false,
            //                 sanitize: false,
            //                 template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-body"></div></div>',
            //                 title: '',
            //                 content: ul,
            //             }).popover('show');

            //         }else{
            //             let item = links[0];
            //             window.open(item.url);
            //         }
            //     }
            // },
            onDownload(node) {
                // this.onDownload({
                //     url: node.url,
                //     name: node.name,
                //     id: node.id
                // });
                this.downloading = true;
                this.$refs.modalLayerDownload.showModal(node);
            },
            toBoundsArray(extent) {
                // clean up extent
                if (isArray(extent)) {
                    return extent.map((val) => {
                        // getCenterForExtent returns an array of strings sometimes (catalog)
                        if (typeof val === 'string' || val instanceof String) {
                            return Number(val);
                        }
                        return val;
                    });
                }
                if (isObject(extent)) {
                    const numericExtent = Object.entries(extent).reduce((r, [k, v]) => {
                        r[k] = (typeof v === 'string' || v instanceof String ? Number(v) : v);
                        return r;
                    }, {});
                    return [
                        numericExtent.minx,
                        numericExtent.miny,
                        numericExtent.maxx,
                        numericExtent.maxy
                    ];
                }
                return null;
            },
            onAddLayerFromCatalogs(params) {
                const defaultState = {
                    loaded: false,
                    loading: false,
                    checked: false,
                    collapsed: true,
                    selected: false,
                    filtered: true,
                    opacity: 1
                };
                let options = params.options;
                let layer = params.layer;
                layer.layers = layer.name;
                layer.name = layer.title;
                layer.active = true;
                layer.state = {
                    ...defaultState,
                    ...{
                        checked: !!layer.visibility,
                        filtered: true,
                        opacity: 1,
                    }
                };
                layer.legend_layer = this.getLegendUrl(layer);//this.getLegendLayer(this.getLegendUrl(layer));
                layer.behavior = behaviorLayer;
                if(layer.infoFormats && isArray(layer.infoFormats) && layer.infoFormats.length>0) {
                    const availableInfoFormats = uniqArray(getAvailableInfoFormatValues());
                    let infoFormats = layer.infoFormats.map(({value}) => value);
                    let infoFormat = infoFormats.find(item => availableInfoFormats.indexOf('application/json') !== -1 && item == 'application/json')
                        || infoFormats.find(item => availableInfoFormats.indexOf('text/html') !== -1 && item == 'text/html')
                            || infoFormats[0];
                    layer.featureInfo = {
                        format: getFormatFromValue(infoFormat)
                        // template:
                        // viewer:
                    };
                }

                let newNode = {...layer};
                this.insertNodeIntoTree(newNode, layer.group || 0);
            },
            getLegendUrl(layer, urlIdx){
                if (layer && layer.type === "wms" && layer.url && layer.legend && layer.legend.imageUrl) {
                    const idx = urlIdx || isArray(layer.url) && Math.floor(Math.random() * layer.url.length);

                    const url = isArray(layer.url) ?
                        layer.url[idx] :
                        layer.url.replace(/[?].*$/g, '');

                    let urlObj = urlUtil.parse(url);
                    let legendUrlObj = urlUtil.parse(layer.legend.imageUrl);

                    return urlUtil.format({
                        host: urlObj.host,
                        protocol: urlObj.protocol,
                        pathname: urlObj.pathname,
                        search: legendUrlObj.search
                    });
                }
                return null;
            },
            getIconLayer(node) {
                return node.icon_layer?.length ? node.icon_layer[0].path : null;
            },
            getLegendLayer(node = {}) {
                let legend = node.legend_layer;
                if(legend) {
                    if(!isArray(legend)){
                        legend = [{'url': legend}];
                    }
                    if(legend.length){
                        legend = legend[0];
                        return legend?.path ?? legend.url;
                    }
                }
                return null;
            },
            getLayers() {
                return [this.layers];
            }
        },
        watch: {
            mapInitialized: {
                immediate: false,
                handler(value, oldValue){
                    if(value){
                        this.loadLayers();
                    }
                },
            },
            selectedNode: {
                immediate: false,
                handler(value){
                    this.activeTooltip();
                },
            },
            inputLayer: debounce(function(val, oldVal) {
                let tree = this.layersTree;
                if(tree) {
                    tree.filterNodes(val, true)
                }
            }, 500),
        }
    }
</script>

<style scoped lang="scss">
    .svg-inline--fa{
        &.nav-icon-layer-search{
            width: 1.25rem !important;
            height: 1.25rem !important;
        }
    }

</style>
<style lang="scss">
    .fa-layer-plus {
        width: 16px;
    }
</style>